// extracted by mini-css-extract-plugin
module.exports = {"list":"Home2ConnectorsSection_list__wbDdc","standaloneRow":"Home2ConnectorsSection_standaloneRow__P6_sW"};